module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1049-6cdf83adab76bade8187018bfb607ce2.png";